<button
  *ngIf="isButtonVisible"
  i18n="@@common.button.collectDocuments"
  type="button"
  class="btn btn-primary"
  (click)="goToDocumentsCollector()"
>Collect Documents</button>
